const Style = {

  base: 'block w-[6em] h-[2em] mx-auto mb-4 outline-none md:w-20'

}

export default Style;
